import React from 'react'
import {connect} from "react-redux";
import Lc from "./lc";
import Windowbutton from "../gui/windowbutton";
import LcControl from "./lc_control";

import NewLc from "./new_lc"

const Lccontainer = ({lcs, root}) => {
    const wi = 220

    return (
        <>
            <Windowbutton close={() => {
            }} headline={'LC'} id={'LC'} width={wi} icon={'LC'}>
                <div style={
                    {
                        zIndex: 20,
                        width: wi,
                        maxHeight: '600px',
                        overflow: "auto",
                        background: '#b8c2bc',
                    }
                }>
                    {root.editmode && <NewLc/>}
                    <Lc key={'_1_'} lc={{name: "lc", id: "", dir: "", v: ""}} small={false}/>
                    {lcs.map(lc => (
                        <Lc key={"list_" + lc.id} lc={lc}/>
                    ))}
                </div>
            </Windowbutton>
            {lcs.map(lc => (
                <LcControl key={"lc_control_" + lc.id} lc={lc}/>
            ))}
        </>
    );
}

function mapStateToProps(state, other) {

    var itms = state.plan.items.filter((itm) => {
        return itm.name === "lc" || itm.type === "lc" && !itm.deleted
    });

    const srt = [].concat(itms).sort((a, b) => parseInt(a.addr) > parseInt(b.addr) ? 1 : -1)

    //console.log(srt)
    return {lcs: srt, root: state.root};
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Lccontainer)